import { FLOPFLIP_STATE_SLICE, flopflipReducer } from '@flopflip/react-redux';
import { combineReducers } from 'redux';

import accounting from 'store/accounting/reducers';
import activeApplicants from 'store/activeApplicants/reducers';
import aeCommandCenterQuality from 'store/aeCommandCenterQuality/reducers';
import aiChat from 'store/aiChat/reducers';
import aiProcessRuns from 'store/aiProcessRuns/reducers';
import analyticsReducers from 'store/analytics/reducers';
import audioRecordings from 'store/audioRecordings/reducers';
import { MASTER_LOGGED_OUT_ACTION_TYPE } from 'store/auth/actions';
import auth from 'store/auth/reducers';
import brokersReducers from 'store/brokers/reducers';
import chatEscalation from 'store/chatEscalation/reducers';
import commandCenterReducers from 'store/commandCenter/reducers';
import commandCenterAnnouncementsAdmin from 'store/commandCenterAnnouncementsAdmin/reducers';
import commandCenterClientProtectionAdmin from 'store/commandCenterClientProtectionAdmin/reducers';
import commandCenterPageConfigReducers from 'store/commandCenterPageConfig/reducers';
import companiesReducers from 'store/companies/reducers';
import companyCenterReducers from 'store/companyCenter/reducers';
import construction from 'store/construction/reducers';
import contactTypes from 'store/contactTypes/reducers';
import documentIntakeReducers from 'store/documentIntake/reducers';
import documentsReducers from 'store/documents/reducers';
import fileRequest from 'store/fileRequest/reducers';
import filters from 'store/filters/reducers';
import formsReducers from 'store/forms/reducers';
import leadAssignmentRules from 'store/leadAssignmentRules/reducers';
import leadWorkspace from 'store/leadWorkspace/reducers';
import halcyonFormCatalogReducers from 'store/loanActions/halcyonFormCatalog/reducers';
import servicelinkFloodProductsReducers from 'store/loanActions/servicelinkFloodProducts/reducers';
import loanApplications from 'store/loanApplications/reducers';
import loanExceptions from 'store/loanExceptions/reducers';
import loanPipelines from 'store/loanPipelines/reducers';
import loanRequests from 'store/loanRequests/reducers';
import loans from 'store/loans/reducers';
import marginCenter from 'store/marginCenter/reducers';
import milestoneDefinitions from 'store/milestoneDefinitions/reducers';
import presence from 'store/presence/reducers';
import pricing from 'store/pricing/reducers';
import programs from 'store/programs/reducers';
import pushNotifications from 'store/pushNotifications/reducers';
import realtors from 'store/realtors/reducers';
import recordingRequirements from 'store/recordingRequirements/reducers';
import search from 'store/search/reducers';
import secondary from 'store/secondary/reducers';
import snapdocsClosingReducers from 'store/snapdocsClosing/reducers';
import snapdocsSubscriptionsReducers from 'store/snapdocsSubscriptions/reducers';
import subCompaniesReducers from 'store/subCompanies/reducers';
import system from 'store/system/reducers';
import teamChat from 'store/teamChat/reducers';
import texmlApplications from 'store/texmlApplications/reducers';
import capitalMarkets from 'store/trades/reducers';
import underwriting from 'store/underwriting/reducers';
import usersReducers from 'store/users/reducers';
import workScheduler from 'store/workScheduler/reducers';

import claims from './claims.reducer';
import confirmationDialog from './confirmationDialog.reducer';
import currentPage from './currentPage.reducer';
import dialogs from './dialogs.reducer';
import globalUi from './globalUi.reducer';
import messages from './messages.reducer';
import popup from './popup.reducer';
import roles from './roles.reducer';
import settings from './settings.reducer';

const createReducer = asyncReducers => (state, action) => {
  const reducer = combineReducers({
    accounting,
    ...aiChat,
    ...aiProcessRuns,
    auth,
    workScheduler,
    confirmationDialog,
    dialogs,
    roles,
    system,
    programs,
    search,
    filters,
    activeApplicants,
    claims,
    audioRecordings,
    underwriting,
    secondary,
    chatEscalation,
    capitalMarkets,
    popup,
    milestoneDefinitions,
    loanPipelines,
    presence,
    currentPage,
    fileRequest,
    messages,
    settings,
    globalUi,
    contactTypes,
    aeCommandCenterQuality,
    commandCenterAnnouncementsAdmin,
    commandCenterClientProtectionAdmin,
    leadAssignmentRules,
    leadWorkspace,
    loanExceptions,
    ...loanRequests,
    construction,
    texmlApplications,
    recordingRequirements,
    ...teamChat,
    ...analyticsReducers,
    ...subCompaniesReducers,
    ...companyCenterReducers,
    ...commandCenterReducers,
    ...commandCenterPageConfigReducers,
    ...loans,
    ...loanApplications,
    ...documentIntakeReducers,
    ...documentsReducers,
    ...formsReducers,
    ...halcyonFormCatalogReducers,
    ...servicelinkFloodProductsReducers,
    ...snapdocsClosingReducers,
    ...snapdocsSubscriptionsReducers,
    ...companiesReducers,
    ...brokersReducers,
    ...usersReducers,
    ...realtors,
    ...pricing,
    ...marginCenter,
    ...pushNotifications,
    ...asyncReducers,
    [FLOPFLIP_STATE_SLICE]: flopflipReducer,
  });

  if (action.type === MASTER_LOGGED_OUT_ACTION_TYPE) {
    state = {
      [FLOPFLIP_STATE_SLICE]: state[FLOPFLIP_STATE_SLICE],
    };
  }

  return reducer(state, action);
};

export default createReducer;
